import { Component, Input, Output, EventEmitter, ChangeDetectorRef, inject, InjectionToken } from '@angular/core';
import {PatientTargetModel, PatientProgramModel, PatientBehaviorModel } from '../../../core/api/models';
import { DomSanitizer } from '@angular/platform-browser';
import { StaffApiService } from '../../../core/api/services/staff-api.service';
import { OfflineDataService } from '../../../core/services/offline-data.service';
import { SupervisorApiService } from '../../../core/api/services';
import { AlertService } from '../../../shared/services/alert.service';
import { SparkLightLoadService } from '../../../core/services/spark-light-load.service';

// The staff target info loads through staff endpoints, so the parent screen shows the target's parent instructions instead.
export const PARENT_TARGET_DETAILS = new InjectionToken<boolean>('PARENT_TARGET_DETAILS');

@Component({
  selector: 'app-target-details',
  templateUrl: './target-details.component.html',
  standalone: false,
})
export class TargetDetailsComponent  {

  @Input() target?: PatientTargetModel;
  @Input() program?: PatientProgramModel | null;
  @Input() behavior?: PatientBehaviorModel | null;
  @Input() isPreview?: boolean;
  showGraph: boolean = false;
  @Output() onCloseDetails: EventEmitter<void> = new EventEmitter<void>();
  readonly isParentView = inject(PARENT_TARGET_DETAILS, { optional: true }) ?? false;

  isEditingTargetNotes: boolean = false;

  isLoadingContent: boolean = false;
  isOfflineMode: boolean = false;

  constructor(
    protected cdRef: ChangeDetectorRef,
    protected sanitizer: DomSanitizer,
    private supervisorApiService: SupervisorApiService,
    private staffApiService: StaffApiService,
    protected alertService: AlertService,
    private offlineDataService: OfflineDataService,
    protected lightLoad: SparkLightLoadService
  ) {
   
  }

  ngOnInit(): void {
    this.isOfflineMode = this.offlineDataService.isInOfflineMode();
    this.loadProgramContent();
  }

  onSeeGraphs(): void {
    this.showGraph = true;
  }
  onHideGraph(): void {
    this.showGraph = false;
  }
  closeDetails(): void {
    this.onCloseDetails.emit();
  }

  startEditingTargetNotes(): void {
    this.isEditingTargetNotes = true;
  }

  cancelEditingTargetNotes(): void {
    this.isEditingTargetNotes = false;
  }

  saveTargetNotes(): void {
    this.staffApiService.ChangeTargetNotes({
      targetId: this.target?.ID!,
      newNotes: this.target?.TargetNotes!,
      shouldMarkAsNew: true
    }).subscribe(() => {
      this.isEditingTargetNotes = false;
    });
  }

  lastModifiedByText(): string {
    if (!this.target?.NotesLastModifiedByUserFullName || !this.target?.NotesLastModifiedDate) {
      return '';
    }
    return 'Last modified by: ' + this.target?.NotesLastModifiedByUserFullName + ' at ';
  }

    private loadProgramContent(): void {
      if (
        !this.program?.ID ||
        this.program.Details != null ||
        this.isOfflineMode ||
        this.lightLoad.isEnabled()
      ) {
        return;
      }

      this.isLoadingContent = true;
      this.supervisorApiService.GetPatientProgramContent({
        programID: this.program.ID
      }).subscribe({
        next: (content) => {
          if (!this.program) {
            this.isLoadingContent = false;
            return;
          }
          this.program.Details = content.Details ?? '';
          this.program.ProgramNotes = content.ProgramNotes;
          this.program.NotesLastModifiedByUserFullName = content.NotesLastModifiedByUserFullName;
          this.program.NotesLastModifiedDate = content.NotesLastModifiedDate;
          this.program.IsProgramNoteNew = content.IsProgramNoteNew;
          this.program.TreatmentGoals = content.TreatmentGoals ?? [];
          this.isLoadingContent = false;
          this.cdRef.detectChanges();
        },
        error: (error) => {
          console.error('Error loading program instructions', error);
          this.alertService.error('Failed to load program instructions');
          this.isLoadingContent = false;
        }
      });
    }
}
